module.exports = __webpack_public_path__ + "static/media/snapshot_onboarding_and_02_a.405c8d14.png";